export const coachCalendarKeys = {
  all: ['coachCalendar'] as const,
  timeslots: (coachId: string, date: string, timezone: string) =>
    [...coachCalendarKeys.all, 'timeslots', coachId, date, timezone] as const,
};
